import PosterPreview from '@/components/poster-preview/component'
import PosterCustomization from '@/components/poster-customization/component'

function getArtist (params) {
  if (params.artist) {
    return params.artist
  }

  return 'all'
}

function getDocumentTitle (artist, template) {
  let replaceWith = ''
  switch (artist) {
    case 'all':
    case 'ingela-p-arrhenius':
      replaceWith = 'Ingela P Arrhenius'
      break
    case 'peytil':
      replaceWith = 'Peytil'
      break
    case 'katarzyna-strozynska-goraj':
      replaceWith = 'Katarzyna Stróżyńska Goraj'
      break
  }

  return template.replace('{{artist}}', replaceWith)
}

export default {
  name: 'posters',
  components: {
    PosterPreview,
    PosterCustomization,
  },

  mounted () {
    this.$store.dispatch('trackViewPosters', {
      list: this.selectedArtist,
      posters: this.postersToTrack
    })
  },

  beforeRouteEnter: (to, from, next) => {
    const artist = getArtist(to.params)
    document.title = getDocumentTitle(artist, document.title)
    next()
  },

  updated () {
    // Make sure we update the titles with the artist names, if they're in the title.
    document.title = getDocumentTitle(this.selectedArtist, document.title)

    this.$store.dispatch('trackViewPosters', {
      list: this.selectedArtist,
      posters: this.postersToTrack
    })
  },

  computed: {
    selectedArtist () {
      return getArtist(this.$route.params)
    },

    postersToShow () {
      let ret = []
      let self = this
      Object.entries(this.$store.getters.postersMetaData).forEach(function (item) {
        // @todo Don't show the "default" handler, which should be removed.
        if (item[0] === 'default') {
          return
        }

        // @todo Fix human-readable name comparison.
        switch (true) {
          case self.selectedArtist === 'all':
          case self.selectedArtist === 'ingela-p-arrhenius' && item[1].artist === 'Ingela P Arrhenius':
          case self.selectedArtist === 'peytil' && item[1].artist === 'Peytil':
          case self.selectedArtist === 'katarzyna-strozynska-goraj' && item[1].artist === 'Katarzyna Stróżyńska Goraj':
            ret.push(item[0])
            break
        }
      })
      return ret
    },

    postersToTrack () {
      let ret = []
      let self = this
      Object.entries(this.$store.getters.postersMetaData).forEach(function (item) {
        // @todo Don't show the "default" handler, which should be removed.
        if (item[0] === 'default') {
          return
        }

        // @todo Fix human-readable name comparison.
        switch (true) {
          case self.selectedArtist === 'all':
          case self.selectedArtist === 'ingela-p-arrhenius' && item[1].artist === 'Ingela P Arrhenius':
          case self.selectedArtist === 'peytil' && item[1].artist === 'Peytil':
          case self.selectedArtist === 'katarzyna-strozynska-goraj' && item[1].artist === 'Katarzyna Stróżyńska Goraj':
            ret.push(item[1])
            break
        }
      })
      return ret
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/posters/script.js